import React, {useState, useEffect} from 'react';
import {useParams} from 'react-router-dom';
import {defaultErrorHandler} from '../../context/context';
import emailV1Client from '../../infrastructure/acerill/email-v1-client';
import SmtpConfig from '../../libs/react-components-admin/email/smtp-config';
import CenteredSpinner from '../../libs/react-components-admin/spinners/centered-spinner';
import Section from '../../libs/react-components-admin/section/section';
import SaveCancelBar from '../../libs/react-components-admin/buttons/save-cancel-bar';

const SmtpConfigPage = () => {

  const {id} = useParams();
  const [smtpConfig, setSmtpConfig] = useState();

  const loadSmtpConfig = () => {
    return emailV1Client.findSmtpConfig(id)
      .then(smtpConfig => setSmtpConfig(smtpConfig || {}));
  };

  useEffect(() => { loadSmtpConfig().catch(defaultErrorHandler); }, [id]);

  const save = () => emailV1Client.saveSmtpConfig({...smtpConfig, id});

  const smtpConfigIsValid = () => smtpConfig.host &&
    (smtpConfig.credentials || {}).username && (smtpConfig.credentials || {}).password &&
    smtpConfig.senderEmailAddress &&
    ((smtpConfig.support || {}).emailAddresses || []).length > 0;

  return <Section title="SMTP configuration" noMargin={true}>
    <div className="row justify-content-center mb-5">
      <div className="col-12 col-md-8">
        {!smtpConfig ?
          <CenteredSpinner/> :
          <>
            <SmtpConfig className="mb-4"
                        initialModel={smtpConfig}
                        onChange={v => setSmtpConfig(v)}/>
            <SaveCancelBar saveAction={() => save()}
                           saveDisabled={!smtpConfigIsValid()}
                           cancelAction={() => {
                             setSmtpConfig(null);
                             return loadSmtpConfig();
                           }}
                           errorHandler={defaultErrorHandler}/>
          </>
        }
      </div>
    </div>
  </Section>;
};

export default SmtpConfigPage;